export const STATUS_OK = 0;
export const STATUS_EXCEEDEDAMOUNT = 1;
export const STATUS_ERRORBLOCKED = 2;
export const STATUS_ERRORWARNING = 3;
export const STATUS_ERRORGENERAL = 4;